import type { Product } from '../../../data/product';
import { formatDate, formatDateISO } from '../../../helpers/format-date';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

// The clock is read per call rather than captured once at module load: the
// bundle is evaluated when the tab first loads, and store owners leave the app
// open for days, so a snapshot would freeze every distance at that moment.
export const LastSold: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Last Sold',
  minWidth: 50,
  accessorFn: (product) => (product.last_sold ? formatDate(product.last_sold, new Date()) : ' -'),
  sortKeyFn: (product) => product.last_sold,
  toCSV: (product) => ({
    'Last Sold': product.last_sold ? formatDateISO(product.last_sold) : '',
  }),
});
